import { styled } from '@mui/material';
import { Box } from '@mui/system';
import { colors } from '@themes/colors';
import { breakpoints, palette, spacing } from '@themes/theme.helpers';

export const GlobalStyles = styled(Box)`
  body {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  // TEXT
  //--------

  // Headers
  h1,
  h2,
  h3,
  h4 {
    color: ${palette.text('primary')};
    font-weight: 400;
    letter-spacing: 0.01em;
    line-height: 120%;
    &.regular {
      font-weight: 400;
    }
    &.no-uppercase {
      text-transform: none;
    }
    &:after {
      content: '•';
      color: ${palette.primary('main')};
      font-size: 0.5em;
      font-weight: normal;
      position: relative;
    }
    &.no-dot {
      &:after {
        display: none;
      }
    }
  }

  h1 {
    font-weight: 600;
    font-size: 32px;
    &:after {
      left: -0.5px;
      top: 1.5px;
    }
    ${breakpoints.up('sm')} {
      font-size: 48px;
      &:after {
        left: -1.5px;
        top: 3px;
      }
    }
    ${breakpoints.up('md')} {
      font-size: 72px;
      &:after {
        left: 0px;
        top: 3px;
      }
    }
  }

  h2 {
    font-weight: 500;
    font-size: 28px;
    &:after {
      left: -0.5px;
      top: 1.2px;
    }
    ${breakpoints.up('sm')} {
      font-size: 32px;
      &:after {
        left: -0.5px;
        top: 2px;
      }
    }
    ${breakpoints.up('md')} {
      font-size: 54px;
      &:after {
        left: -1.5px;
        top: 3.5px;
      }
    }
  }

  h3 {
    font-size: 24px;
    &:after {
      left: -0.5px;
      top: 1px;
    }

    ${breakpoints.up('lg')} {
      font-size: 32px;
      &:after {
        left: -1px;
        top: 2px;
      }
    }
  }

  h4 {
    font-size: 24px;
    &:after {
      left: -0.5px;
      top: 1px;
    }
  }

  h5 {
    font-weight: 400;
    font-size: 24px;
  }

  // Default paragraph text
  p {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 160%;
    text-align: justify;
    letter-spacing: 0.01em;
  }

  .html-wrapper p,
  .html-wrapper li,
  .html-wrapper span {
    font-size: 16px !important;
  }

  .html-wrapper p[style*='font-size: 8pt;'],
  .html-wrapper p[style*='font-size:8pt;'],
  .html-wrapper span[style*='font-size: 8pt;'],
  .html-wrapper span[style*='font-size:8pt;'],
  .html-wrapper li[style*='font-size: 8pt;'],
  .html-wrapper li[style*='font-size:8pt;'] {
    font-size: 12px !important;
  }

  .html-wrapper p[style*='font-size: 10pt;'],
  .html-wrapper p[style*='font-size:10pt;'],
  .html-wrapper span[style*='font-size: 10pt;'],
  .html-wrapper span[style*='font-size:10pt;'],
  .html-wrapper li[style*='font-size: 10pt;'],
  .html-wrapper li[style*='font-size:10pt;'] {
    font-size: 14px !important;
  }

  .html-wrapper p[style*='font-size: 12pt;'],
  .html-wrapper p[style*='font-size:12pt;'],
  .html-wrapper span[style*='font-size: 12pt;'],
  .html-wrapper span[style*='font-size:12pt;'],
  .html-wrapper li[style*='font-size: 12pt;'],
  .html-wrapper li[style*='font-size:12pt;'],
  .html-wrapper p[style*='font-size: 14pt;'],
  .html-wrapper p[style*='font-size:14pt;'],
  .html-wrapper span[style*='font-size: 14pt;'],
  .html-wrapper span[style*='font-size:14pt;'],
  .html-wrapper li[style*='font-size: 14pt;'],
  .html-wrapper li[style*='font-size:14pt;'] {
    font-size: 16px !important;
  }

  .html-wrapper p[style*='font-size: 18pt;'],
  .html-wrapper p[style*='font-size:18pt;'],
  .html-wrapper span[style*='font-size: 18pt;'],
  .html-wrapper span[style*='font-size:18pt;'],
  .html-wrapper li[style*='font-size: 18pt;'],
  .html-wrapper li[style*='font-size:18pt;'] {
    font-size: 18px !important;
  }

  .html-wrapper p[style*='font-size: 24pt;'],
  .html-wrapper p[style*='font-size:24pt;'],
  .html-wrapper span[style*='font-size: 24pt;'],
  .html-wrapper span[style*='font-size:24pt;'],
  .html-wrapper li[style*='font-size: 24pt;'],
  .html-wrapper li[style*='font-size:24pt;'] {
    font-size: 20px !important;
  }
  .html-wrapper p[style*='font-size: 36pt;'],
  .html-wrapper p[style*='font-size:36pt;'],
  .html-wrapper span[style*='font-size: 36pt;'],
  .html-wrapper span[style*='font-size:36pt;'],
  .html-wrapper li[style*='font-size: 36pt;'] {
    font-size: 28px !important;
  }

  ${breakpoints.up('md')} {
    .html-wrapper p,
    .html-wrapper li,
    .html-wrapper span {
      font-size: 18px !important;
    }

    .html-wrapper p[style*='font-size: 10pt;'],
    .html-wrapper p[style*='font-size:10pt;'],
    .html-wrapper span[style*='font-size: 10pt;'],
    .html-wrapper span[style*='font-size:10pt;'],
    .html-wrapper li[style*='font-size: 10pt;'],
    .html-wrapper li[style*='font-size:10pt;'] {
      font-size: 16px !important;
    }
    .html-wrapper p[style*='font-size: 12pt;'],
    .html-wrapper p[style*='font-size:12pt;'],
    .html-wrapper span[style*='font-size: 12pt;'],
    .html-wrapper span[style*='font-size:12pt;'],
    .html-wrapper li[style*='font-size: 12pt;'],
    .html-wrapper li[style*='font-size:12pt;'] {
      font-size: 18px !important;
    }
    .html-wrapper p[style*='font-size: 14pt;'],
    .html-wrapper p[style*='font-size:14pt;'],
    .html-wrapper span[style*='font-size: 14pt;'],
    .html-wrapper span[style*='font-size:14pt;'],
    .html-wrapper li[style*='font-size: 14pt;'],
    .html-wrapper li[style*='font-size:14pt;'] {
      font-size: 20px !important;
    }
    .html-wrapper p[style*='font-size: 18pt;'],
    .html-wrapper p[style*='font-size:18pt;'],
    .html-wrapper span[style*='font-size: 18pt;'],
    .html-wrapper span[style*='font-size:18pt;'],
    .html-wrapper li[style*='font-size: 18pt;'],
    .html-wrapper li[style*='font-size:18pt;'] {
      font-size: 24px !important;
    }
    .html-wrapper p[style*='font-size: 24pt;'],
    .html-wrapper p[style*='font-size:24pt;'],
    .html-wrapper span[style*='font-size: 24pt;'],
    .html-wrapper span[style*='font-size:24pt;'],
    .html-wrapper li[style*='font-size: 24pt;'],
    .html-wrapper li[style*='font-size:24pt;'] {
      font-size: 32px !important;
    }
  }

  // LINK
  // There are different variants used in different places

  .MuiLink-root,
  .link {
    &.primary {
      color: ${colors.text.primary};
    }
    &.bold {
      font-weight: 600;
    }
    &.uppercase {
      text-transform: uppercase;
    }
    &.underline {
      text-decoration: underline;
    }
  }

  // BUTTONS
  //---------

  // Button base - target custom components, MUI and EPI Forms
  .button,
  .MuiButton-root,
  .FormSubmitButton,
  .FormResetButton,
  .FormCaptcha__Refresh {
    text-transform: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.01em;
    border: 0;
    cursor: pointer;
    text-decoration: none !important;
  }

  .button,
  .MuiButton-root.MuiButton-sizeSmall {
    font-size: 16px;
    padding: 4px 16px;
    min-width: 80px;
    height: 34px;
  }

  .button,
  .MuiButton-root.MuiButton-sizeMedium {
    font-size: 16px;
    padding: 8px 24px;
    min-width: 104px;
    height: 42px;
  }

  .button,
  .MuiButton-root.MuiButton-sizeLarge {
    font-size: 16px;
    padding: 21px 40px;
    min-width: 488px;
    height: 64px;
  }

  .MuiButton-root {
    border-radius: 16px;
  }

  .button-primary,
  .MuiButton-root.MuiButton-primary {
    padding: 8px 24px;
    gap: 8px;
    min-width: 104px;
    max-width: 100%;
    font-weight: 400;
    height: 42px;
    background-color: ${palette.primary('main')};
    border-radius: 16px;
    color: ${colors.secondary.black};

    &:hover {
      text-shadow: 1px 0 0 currentColor;
    }
  }

  .button-primary,
  .MuiButton-root.MuiButton-primary.MuiButton-sizeSmall {
    font-size: 16px;
    padding: 4px 16px;
    min-width: auto;
    height: auto;
  }

  .button-secondary,
  .MuiButton-root.MuiButton-secondary,
  .FormSubmitButton {
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.01em;
    color: #1c1c1c;
    background-color: ${colors.secondary.light};
    border: 1px solid ${colors.primary.mainGreen};

    &:hover {
      text-shadow: 1px 0 0 currentColor;
      border: 1px solid transparent;
    }
  }

  .button-primary,
  .MuiButton-root.MuiButton-secondary.MuiButton-sizeSmall {
    font-size: 14px;
    padding: 4px 16px;
    min-width: auto;
    height: auto;
  }

  .button-tertiary,
  .MuiButton-root.MuiButton-tertiary,
  .FormCaptcha__Refresh,
  .FormResetButton {
    // TODO [KF][KL] - color outside palette?
    background: #ede9e7;
    // TODO [KF][KL] - color outside palette?
    color: #515151;

    &:hover {
      text-shadow: 1px 0 0 currentColor;
    }
  }

  .button-ghost,
  .MuiButton-root.MuiButton-ghost {
    color: ${colors.primary.mainGreen};
    border: 1px solid ${colors.primary.mainGreen};
    padding-left: 24px;
    padding-right: 24px;

    &:hover {
      text-shadow: 1px 0 0 currentColor;
    }
  }

  .button-inactive,
  .MuiButton-root.Mui-disabled {
    opacity: 0.5;
  }

  .FormSubmitButton {
    display: inline-block;
  }

  .FormSubmitButton,
  .FormResetButton {
    min-width: 100%;
    border-radius: 16px !important;
    ${breakpoints.up('md')} {
      flex-direction: row;
      min-width: 200px;
      display: inline-block;
    }
  }

  // Add spacing between buttons
  .FormSubmitButton + .FormResetButton,
  .FormResetButton + .FormSubmitButton {
    ${breakpoints.up('md')} {
      display: inline-block;
      margin-left: 24px;
    }
  }

  // FORMS
  // Style EPI Forms + override some MUI to achieve similar look and feel
  //-----------------------------------------------------------------------

  // Reset styles on the MUI inputs
  .MuiInputBase-root,
  .MuiOutlinedInput-root,
  .MuiFormControl-root {
    fieldset {
      top: 0;
    }
    legend {
      display: none;
    }
  }

  // Reset styles on the EPI inputs
  .FormElement,
  .Form__Element {
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;
  }

  // EPI Element - Text
  .FormTextbox__Input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.23);
    background: none;
    height: 44px;
    padding: 10px 12px;
    gap: 30px;
    border-radius: 4px;
    background-color: #fff;
    outline: none;
    &:hover {
      border-color: ${palette.text('primary')};
    }
    &:focus {
      border-color: ${palette.primary('main')};
      border-width: 2px;
      padding: 9px 11px;
    }
  }

  // EPI Element - TextArea
  .FormTextbox--Textarea {
    textarea {
      min-height: 150px;
      ${breakpoints.up('md')} {
        min-height: 150px;
        min-width: 500px;
      }
    }
  }

  // EPI Element -
  .FormSelection {
    select {
      display: flex;
      flex-direction: row;
      height: 100px;
      padding: 10px 12px;
      font-family: 'Lato', sans-serif;
      font-size: 16px;
      // TODO [KF] - extract color
      border: 1px solid rgba(0, 0, 0, 0.23);
      border-radius: 4px;
      &:hover {
        border-color: ${palette.text('primary')};
      }
      &:focus {
        border-color: ${palette.primary('main')};
        border-width: 2px;
        padding: 9px 11px;
      }
    }
  }

  .FormChoice {
    display: flex;
    fieldset {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      border: none;
      padding: 0;
      ${breakpoints.up('md')} {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 24px;
        width: 100%;
        flex-wrap: wrap;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 25px;
      ${breakpoints.up('md')} {
        flex-direction: column;
        justify-content: space-between;
      }
    }

    .FormChoice__Input--Radio,
    .FormChoice__Input--Checkbox {
      box-sizing: border-box;
      appearance: none;
      cursor: pointer;
      width: 26px !important;
      height: 26px !important;
      outline: 1px solid rgba(0, 0, 0, 0.23);
      outline-offset: 3px;
      ${breakpoints.up('md')} {
        width: 20px !important;
        height: 20px !important;
        margin: 0 0 8px 0;
      }

      &:checked {
        background: ${colors.primary.mainGreen};
        outline: 2px solid ${colors.primary.mainGreen};
      }
    }

    .FormChoice__Input--Radio {
      border-radius: 50%;
    }

    .FormChoice__Input--Checkbox {
      border-radius: 4px;
      &:checked {
        background: ${colors.primary.mainGreen} url(/icons/checked.svg);
        background-size: 16px;
        background-position: center;
        background-repeat: no-repeat;
      }
    }

    .FormChoice__Label {
      margin-left: 15px;
      ${breakpoints.up('md')} {
        margin: 3px;
      }
    }
  }

  .MuiFormLabel-root,
  .MuiInputLabel-root,
  .FormElement label,
  .Form__Element label,
  .Form__Element__Caption {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 0.01em;
    color: #4f4f4f;
    font-size: 16px;
    margin: 0 0 0 12px;
    ${breakpoints.up('md')} {
      margin: 0 0 0 12px;
    }
  }

  .padding-x {
    padding-left: 16px;
    padding-right: 16px;
  }

  .FormChoice {
    .Form__Element__Caption {
      text-align: center;
      margin-left: 0;
      margin-bottom: ${spacing(2)};
    }
  }

  .FormCaptcha__Refresh {
    display: inline-block;
    height: 44px !important;
    border-radius: 4px !important ;
    ${breakpoints.up('md')} {
      margin: -16px 0 0 16px;
    }
  }

  // FORM - centered design
  // All form - centering overrides should be under this selector
  //--------------------------------------------------------------
  .EPiServerForms {
    text-align: center;
    max-width: 700px;
    margin: 0 auto;

    .Form__Element {
      width: 100%;
      input,
      textarea,
      select {
        width: 100%;
      }

      label {
        float: left;
        text-align: left;
      }
    }

    .FormTextbox__Input {
      display: block;
    }

    .FormSubmitButton,
    .FormResetButton {
      ${breakpoints.up('md')} {
        display: inline-block;
        padding: 8px 24px;
        gap: 8px;
        height: 42px;
        font-weight: 400;
        margin-right: 0;
        margin-left: 0;
        max-width: 400px;
        color: #000000;
        background-color: ${colors.primary.mainGreen};
      }
    }

    .Form__Status .Form__Success__Message {
      background-color: ${colors.primary.lightGreen} !important;
    }

    .FormCaptcha {
      text-align: left;
      .FormCaptcha__Image {
        margin: 16px auto;
        display: inline-block;
      }
    }
  }

  // FORMS - REQUEST MODALS

  .request-modal {
    max-width: 550px;
    margin: 0 auto;
    .FormSubmitButton {
      width: 100%;
      height: 64px;
      max-width: none;
    }
  }

  // Additional product info element
  .product-info-element {
    height: 100px;
    display: flex;
    gap: 16px;
    background: #fff;
    padding: 24px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;

    .product-image-cell {
      flex-grow: 0;
      width: 50px;
    }

    .product-info-cell {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;
    }

    .product-price-cell {
      flex-grow: 0;
      width: 100px;
      display: flex;
      align-items: center;
    }

    .product-image {
      width: 50px;
      height: 50px;
      object-fit: contain;
    }

    .product-name,
    .product-price {
      font-family: Lato;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: 0.01em;
      text-align: left;
      color: #1c1c1c;
    }
  }

  //product details tabs bar
  .full-width-bar.normal {
    visibility: hidden;
  }

  // UTILITIES

  .wrap {
    word-wrap: break-word;
  }

  .line-clamp-2 {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  // SHADOWS
  .hover-shadow {
    transition: all 200ms linear;
    // TODO [KF] - test unification with other components that don't have shadow
    // MUI shadow level 3
    /* box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%),
      0px 1px 8px 0px rgb(0 0 0 / 12%); */
    // MUI Shadow level 6
    ${breakpoints.up('md')} {
      &:hover {
        box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%),
          0px 1px 18px 0px rgb(0 0 0 / 12%);
        transform: scale(1.03);
      }
    }
  }
  @media print {
    header,
    nav,
    .footer-section,
    .breadcrumb-wrapper {
      display: none;
    }

    .warranty-details-block .warranty-file-upload,
    .warranty-details-block button,
    .buyers-certificate-details button,
    .buyers-certificate-details a,
    .warranty-details-block a {
      display: none;
    }

    .warranty-details-block,
    .buyers-certificate-details {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;
